(function () {
  function initMacaronsCouponCards() {
    document.querySelectorAll('.macarons-coupon-card').forEach(function (section) {
      if (section.dataset.macaronsCouponInitialized === 'true') return;
      section.dataset.macaronsCouponInitialized = 'true';

      section.addEventListener('click', function (event) {
        var button = event.target.closest('[data-coupon-code]');

        if (!button || !section.contains(button)) return;

        var code = button.getAttribute('data-coupon-code');
        var copyText = button.querySelector('.macarons-coupon-card__copy-text');
        var successText = button.getAttribute('data-success-text') || 'Copied!';
        var originalText = button.getAttribute('data-original-text') || (copyText ? copyText.textContent : 'Tap to copy');

        if (!code) return;

        function copied() {
          button.classList.add('is-copied');

          if (copyText) {
            copyText.textContent = successText;
          }

          setTimeout(function () {
            button.classList.remove('is-copied');

            if (copyText) {
              copyText.textContent = originalText;
            }
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(copied).catch(function () {
            fallbackCopy(code, copied);
          });
        } else {
          fallbackCopy(code, copied);
        }
      });
    });
  }

  function fallbackCopy(text, callback) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      callback();
    } catch (error) {
      console.warn('Coupon code could not be copied.');
    }

    document.body.removeChild(textarea);
  }

  document.addEventListener('DOMContentLoaded', initMacaronsCouponCards);
  document.addEventListener('shopify:section:load', initMacaronsCouponCards);
})();